export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_AUTH_ERRORS = "SET_AUTH_ERRORS";
export const CLEAR_AUTH_ERRORS = "CLEAR_AUTH_ERRORS";
export const SET_AUTH_LOADER = "SET_AUTH_LOADER";
export const CLEAR_AUTH_LOADER = "CLEAR_AUTH_LOADER";
